"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiDispatchify = void 0;
function multiDispatchify(originalMethod, dispatchesAmount) {
    return function (...args) {
        return new Promise((resolve, reject) => {
            let rejectionsAmount = 0;
            const catchHandler = (e) => {
                rejectionsAmount += 1;
                if (rejectionsAmount === dispatchesAmount) {
                    reject(e);
                }
            };
            for (let i = 1; i <= dispatchesAmount; i += 1) {
                originalMethod.apply(this, ...args)
                    .then(resolve)
                    .catch(catchHandler);
            }
        });
    };
}
exports.multiDispatchify = multiDispatchify;
